<div class="default-images-container">
  <div class="info-block">
    <mat-icon class="info-block__icon">info_outline</mat-icon>
    <span>{{ 'MENU_EDIT.DEFAULT_IMAGE.HINT' | translate }}</span>
  </div>

  <div class="status-row">
    <span *ngIf="loading" class="loading-indicator">
      {{ 'COMMON.LOADING' | translate }}
    </span>
    <span *ngIf="error" class="error-message">
      {{ error }}
    </span>
  </div>

  <div class="cards" *ngIf="!loading">
    <div class="card" *ngFor="let card of cards">
      <div class="card-title">{{ card.titleKey | translate }}</div>

      <div class="card-preview">
        <img [src]="getImageSrc(card.positionType)" [alt]="card.titleKey | translate">
      </div>

      <div
        class="card-badge"
        [class.card-badge--custom]="isCustom(card.positionType)"
      >
        {{ (isCustom(card.positionType)
            ? 'MENU_EDIT.DEFAULT_IMAGE.CUSTOM'
            : 'MENU_EDIT.DEFAULT_IMAGE.STANDARD') | translate }}
      </div>

      <div class="card-actions">
        <input
          #uploadFile
          class="upload-input"
          type="file"
          accept="image/*"
          (change)="onImageSelected($event, card.positionType)"
        >
        <button
          mat-raised-button
          color="accent"
          [disabled]="isSaving(card.positionType)"
          (click)="uploadFile.click()"
        >{{ 'MENU_EDIT.DEFAULT_IMAGE.UPLOAD' | translate }}</button>
        <button
          mat-stroked-button
          [disabled]="isSaving(card.positionType) || !isCustom(card.positionType)"
          (click)="onResetToStandard(card.positionType)"
        >{{ 'MENU_EDIT.DEFAULT_IMAGE.RESET' | translate }}</button>
      </div>

      <mat-progress-spinner
        *ngIf="isSaving(card.positionType)"
        class="card-spinner"
        diameter="24"
        mode="indeterminate"
      ></mat-progress-spinner>
    </div>
  </div>
</div>
